module.exports = {
	name: 'foot-nav',
	data() {
		return {};
	}
};


// WEBPACK FOOTER //
// ./src/components/Common/FootNav/FootNav.js